import { Controller } from "stimulus"
import Turbolinks from "turbolinks"

export default class extends Controller {
  showPaymentForm(e) {
    Turbolinks.visit(e.currentTarget.dataset.url)
  }
}
